// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation-minimal {
  width: 440px;
  height: 556px;
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 70vh;
  max-width: 80vw;
  padding-top: 16px;
}
.dl-core-navigation-minimal .dl-core-navigation {
  height: calc(100% - 40px);
}
.dl-core-navigation-minimal .dl-core-navigation__entries-header {
  flex-wrap: wrap;
}
.dl-core-navigation-minimal .dl-core-navigation__search {
  margin-right: 0;
  margin-bottom: 8px;
}
.dl-core-navigation-minimal__header {
  display: flex;
  align-items: center;
  padding: 0 20px 8px 12px;
  flex: 0 0 auto;
}
.dl-core-navigation-minimal__controls {
  display: flex;
  align-items: center;
  width: 100%;
}
.dl-core-navigation-minimal__footer {
  padding: 8px 16px 16px;
  display: flex;
  flex: 1 0 auto;
  gap: 16px;
}
.dl-core-navigation-minimal__footer-navigation-actions {
  display: flex;
  flex: 1 0 auto;
  justify-content: flex-end;
  gap: 8px;
}
.dl-core-navigation-minimal__footer-button {
  min-width: 128px;
}
.dl-core-navigation-minimal__popup {
  border-radius: 4px;
  overflow: hidden;
  background-color: var(--g-color-base-float);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/NavigationMinimal.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ;AACI;EACI,yBAAA;AACR;AACQ;EACI,eAAA;AACZ;AAEQ;EACI,eAAA;EACA,kBAAA;AAAZ;AAII;EACI,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAHR;AAMI;EACI,sBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;AAJR;AAOI;EACI,aAAA;EACA,cAAA;EACA,yBAAA;EACA,QAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,kBAAA;EACA,gBAAA;EACA,2CAAA;AAPR","sourcesContent":[".dl-core-navigation-minimal {\n  width: 440px;\n  height: 556px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-height: 70vh;\n  max-width: 80vw;\n  padding-top: 16px;\n}\n.dl-core-navigation-minimal .dl-core-navigation {\n  height: calc(100% - 40px);\n}\n.dl-core-navigation-minimal .dl-core-navigation__entries-header {\n  flex-wrap: wrap;\n}\n.dl-core-navigation-minimal .dl-core-navigation__search {\n  margin-right: 0;\n  margin-bottom: 8px;\n}\n.dl-core-navigation-minimal__header {\n  display: flex;\n  align-items: center;\n  padding: 0 20px 8px 12px;\n  flex: 0 0 auto;\n}\n.dl-core-navigation-minimal__controls {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.dl-core-navigation-minimal__footer {\n  padding: 8px 16px 16px;\n  display: flex;\n  flex: 1 0 auto;\n  gap: 16px;\n}\n.dl-core-navigation-minimal__footer-navigation-actions {\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.dl-core-navigation-minimal__footer-button {\n  min-width: 128px;\n}\n.dl-core-navigation-minimal__popup {\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: var(--g-color-base-float);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
